
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable, throwError } from 'rxjs';
import { CmsImage } from '../models/cms-image.model';
import StsFooterModel from '../models/sts-footer.model';
import { StsHttpService } from './sts-http.service';

@Injectable()
export class StsCmsService {

  // private imagesUrl = 'StsImages';  // URL to web API
  private imagesUrl = 'http://CMSWidget/imageurl/';  // URL to web API

  private images: { [id: string]: CmsImage; } = {};
  private texts: { [id: string]: string; } = {};


  constructor (private http: StsHttpService) {
  }

  public getText(key: string):  Observable<string> {
    return new Observable<string>(o => {
      if (this.texts.hasOwnProperty(key)) {
        o.next(this.texts[key]);
        o.complete();
      } else {
        if (document.location.href.indexOf('debugtext') !== -1 || document['debugtext']) {
          console.log('cms text >> ' + key);
        }
        key = `/api/texts/${key}`;
        this.http.get<string>(key).subscribe( (txt: string) => {
          this.texts[key] = txt;
          o.next(this.texts[key]);
          o.complete();
        });
      }

    });
  }


  public getFooter():  Observable<StsFooterModel> {

    return new Observable<StsFooterModel>(o => {

      this.http.get<StsFooterModel>(`/api/sts-json/footer`).subscribe(
        (m: StsFooterModel) => {
          o.next(m);
          o.complete();
        });

    });
  }


  public getImage(key: string):  Observable<CmsImage> {
    let me = this;
    return new Observable<CmsImage>(o => {

      if (me.images.hasOwnProperty(key)) {
        o.next(me.images[key]);
        o.complete();
      } else {
        if ( document.location.href.indexOf('debugimage') !== -1 || document['debugimage']) {
          console.log('cms image >> ', key);
        }
        me.getImageFromCms(key).subscribe((imgs: CmsImage) => {
          if (imgs && (!imgs.name || !imgs.name)) {
            imgs = null;
          }
          me.images[key] = imgs;
          o.next(me.images[key]);
          o.complete();
        });
      }

    });
  }

  private getImageFromCms (key: string): Observable<CmsImage> {
    return this.http.get<CmsImage>(key);
  }

  private getPictureName(str: string): string {
    let re = new RegExp('/');
    let fName = (str || '').split(re).pop();
    return fName;
  }


  private handleError (error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return throwError(errMsg);
  }

}
